import { render, staticRenderFns } from "./RstComp.vue?vue&type=template&id=6bc3c5f4"
import script from "./RstComp.vue?vue&type=script&lang=js"
export * from "./RstComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports